module.exports = __webpack_public_path__ + "img/sketchfab.9339ba3b.png";